import { render, staticRenderFns } from "./ProductionEditDetail.vue?vue&type=template&id=39e6c3d8&"
import script from "./ProductionEditDetail.vue?vue&type=script&lang=js&"
export * from "./ProductionEditDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports